export const PairsGrid: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-3 p-3 lg:gap-4 lg:p-4">
      {children}
    </div>
  );
};
